interface AuthResponse {
  user?: {
    id: string;
    email: string;
    name: string;
    picture: string;
  };
  credential?: string;
  error?: string;
  type: "AUTH_SUCCESS" | "AUTH_ERROR";
}

export const initiateGoogleLogin = () => {
  return new Promise<AuthResponse["user"]>((resolve, reject) => {
    // So developers can test without Google OAuth
    const developer = process.env.REACT_APP_USER;
    if (developer) {
      const dev = JSON.parse(developer);
      if (dev) {
        resolve(dev);
        return;
      }
    }

    // Configure popup window dimensions
    const width = 500;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    // Open the popup window for Google OAuth
    const popup = window.open(
      `${process.env.REACT_APP_API_URL}/auth/google/oauth`,
      "Google Login",
      `width=${width},height=${height},left=${left},top=${top}`
    );

    // Listen for the authentication response from the popup
    function authMessageListener(event: MessageEvent<AuthResponse>) {
      // Security check: ensure message is from our backend
      if (event.origin !== `${process.env.REACT_APP_MEDIA_URL}`) return;

      // Handle the authentication response
      if (event.data.type === "AUTH_SUCCESS" && event.data.user) {
        localStorage.setItem("googleToken", JSON.stringify(event.data.user));
        localStorage.setItem("tokenExpiry", (Date.now() + 3600000).toString());

        console.log("In GoogleLogin.ts, user: ", event.data.user);
        resolve(event.data.user);
      } else if (event.data.type === "AUTH_ERROR") {
        reject(event.data.error || "Authentication failed");
      }

      // Clean up: remove listener and close popup
      window.removeEventListener("message", authMessageListener);

      // Might need to remove this if it causes a browser warning
      if (popup) popup.close();
    }

    // Attach the listener to receive the message from the popup
    window.addEventListener("message", authMessageListener);

    // Handle case where popup is blocked or closed
    const popupCheckInterval = setInterval(() => {
      if (!popup || popup.closed) {
        clearInterval(popupCheckInterval);
        window.removeEventListener("message", authMessageListener);
        reject("Authentication cancelled");
      }
    }, 1000);
  });
};
